import { Question } from '../shared/question';
import { ApplicationStorage } from './applicationStorage';
import { SurveyService } from './surveyService';
import { WinstonWave2Survey } from './WIN_W2_SURVEY';

import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, throwError, of, lastValueFrom } from 'rxjs' //'rxjs/dist/types/internal/Observable';
import { map, catchError, ignoreElements } from 'rxjs/operators'
import { Injectable } from '@angular/core';
import { OneToOneSegment1Win } from './121_SEGMENT_1_WIN';
import { OneToOneSegment2Win } from './121_SEGMENT_2_WIN';
import { OneToOneSegment3Win } from './121_SEGMENT_3_WIN';
import { OneToOneSegment4Win } from './121_SEGMENT_4_WIN';
import { OneToOneSegment1Sob } from './121_SEGMENT_1_SOB';
import { OneToOneSegment2Sob } from './121_SEGMENT_2_SOB';
import { OneToOneSegment3Sob } from './121_SEGMENT_3_SOB';
import { OneToOneSegment4Sob } from './121_SEGMENT_4_SOB';
import { Ploom } from './PLOOM';
import { Ploom2 } from './PLOOM2';
import { Ploom3 } from './PLOOM3';
import { PloomAdoptionCallOne } from './PloomAdoptionCallOne';
import { SurveyCall1Adoption } from './SurveyCall1';
import { SurveyCall2Adoption } from './SurveyCall2';
import { SurveyDay14Adoption } from './SurveyDay14';
import { Survey14DaysTrial } from './Survey14DaysTrial';
import { FeedbackSurveyPloom } from './feedback_Survey_ploom'
import { SurveyDay14OnboardingG4 } from './SurveyDay14OnboardingG4';
import { SurveyDay14AdoptionG4 } from './SurveyDay14AdoptionG4';
import { Ploom4 } from './PLOOM4';
import { SurveyBurgundy } from './SurveyBurgundy';





@Injectable()
export class QuestionsService {

    questions!: Array<Question>;
    surveyType: string | undefined = '';

    constructor(private applicationStorage: ApplicationStorage, private surveyService: SurveyService) {

    }

    getQuestions(): Array<Question> {
        if (this.questions === undefined) {
            let surveyType = this.applicationStorage.storage.get("surveyType");
            let surveyConsumerAgreement = this.applicationStorage.storage.get("surveyConsumerAgreement");
            let surveyOutroText = this.applicationStorage.storage.get("surveyOutroText");
            let surveyIntroText = this.applicationStorage.storage.get("surveyIntroText");


            if (surveyType === 'WIN_W2_SURVEY') {
                this.questions = new WinstonWave2Survey().getQuestions();
            } else if (surveyType === '121_SEGMENT_1_WIN') {
                this.questions = new OneToOneSegment1Win().getQuestions();
            } else if (surveyType === '121_SEGMENT_2_WIN') {
                this.questions = new OneToOneSegment2Win().getQuestions();
            } else if (surveyType === '121_SEGMENT_3_WIN') {
                this.questions = new OneToOneSegment3Win().getQuestions();
            } else if (surveyType === '121_SEGMENT_4_WIN') {
                this.questions = new OneToOneSegment4Win().getQuestions();
            } else if (surveyType === '121_SEGMENT_1_SOB') {
                this.questions = new OneToOneSegment1Sob().getQuestions();
            } else if (surveyType === '121_SEGMENT_2_SOB') {
                this.questions = new OneToOneSegment2Sob().getQuestions();
            } else if (surveyType === '121_SEGMENT_3_SOB') {
                this.questions = new OneToOneSegment3Sob().getQuestions();
            } else if (surveyType === '121_SEGMENT_4_SOB') {
                this.questions = new OneToOneSegment4Sob().getQuestions();
            } else if (surveyType === 'PLOOM') {
                this.questions = new Ploom().getQuestions();
            } else if (surveyType === 'PLOOM2') {
                this.questions = new Ploom2(this.applicationStorage).getQuestions();
            } else if (surveyType === 'PloomAdoptionCall2Survey') {
                this.questions = new SurveyCall2Adoption(this.applicationStorage).getQuestions();

            } else if (surveyType === 'PloomAdoptionCall1Survey') {
                this.questions = new SurveyCall1Adoption(this.applicationStorage).getQuestions();

            } else if (surveyType === 'SurveyDay14Adoption') {
                this.questions = new SurveyDay14Adoption(this.applicationStorage).getQuestions();

            } else if (surveyType === 'Ploom14DaysTrial') {
                this.questions = new Survey14DaysTrial(this.applicationStorage).getQuestions();



            } else if (surveyType === 'FeedbackPloom') {
                this.questions = new FeedbackSurveyPloom(this.applicationStorage).getQuestions();


            }
            else if (surveyType === 'SurveyDay14OnboardingG4') {
                this.questions = new SurveyDay14OnboardingG4(this.applicationStorage).getQuestions();

            }
            else if (surveyType === 'SurveyDay14AdoptionG4') {
                this.questions = new SurveyDay14AdoptionG4(this.applicationStorage).getQuestions();

            }

            else if (surveyType === 'PLOOM3_1' || surveyType === 'PLOOM3_2' || surveyType === 'PLOOM3_3' || surveyType === 'PLOOM3_6' || surveyType === 'PLOOM3_12') {
                console.log('surveyType: *********', surveyType)
                this.questions = new Ploom3(this.applicationStorage).getQuestions();
            }
            else if (surveyType === 'PLOOM4_1' || surveyType === 'PLOOM4_2' || surveyType === 'PLOOM4_3' || surveyType === 'PLOOM4_6' || surveyType === 'PLOOM4_12') {
                console.log('surveyType: *********', surveyType)
                this.questions = new Ploom4(this.applicationStorage).getQuestions();
            }
            else if (surveyType === 'SurveyBurgundy') {
                this.questions = new SurveyBurgundy(this.applicationStorage).getQuestions();
            }
            else {
                /* TODO PT PROD */
                this.questions = new Array();
                /* PT LOCAL */
                // this.questions = new SurveyCall1Adoption(this.applicationStorage).getQuestions();
            }

            this.surveyType = surveyType;
        }
        return this.questions;
    }

    getSurveyType(): string | undefined {
        return this.surveyType;
    }
}

